import React, { Suspense } from 'react';

const Home = React.lazy(() => import('../components/Home'));
const Decisions = React.lazy(() => import('../components/Decisions'));
const Sax = React.lazy(() => import('../components/Sax'));
const HiringVideo = React.lazy(() => import('../components/HiringVideo'));
const MarketingIntern = React.lazy(() => import('../components/MarketingIntern'));
const InterviewingFlow = React.lazy(() => import('../components/InterviewingFlow'));
const SongLength = React.lazy(() => import('../components/SongLength'));

export type SiteRoute = {
  path: string;
  element: React.ReactElement;
  title: string;
  description: string;
  image?: string;
  imageType?: string;
  canonicalPath?: string;
};

function lazyPage(element: React.ReactElement): React.ReactElement {
  return <Suspense fallback={<div />}>{element}</Suspense>;
}

export const siteRoutes: SiteRoute[] = [
  {
    path: '/',
    element: lazyPage(<Home />),
    title: "Marc Plotkin | Official Site",
    description: "Grammy-Shortlisted Producer, Songwriter, Singer, Sax & Guitar Player. Bloomberg BizWeek Top 25 Entrepreneur. Professor at NYU's Clive Davis Institute.",
  },
  {
    path: '/decisions',
    element: lazyPage(<Decisions />),
    title: "Decision Making Flow | Marc Plotkin",
    description: "A framework for making better decisions",
  },
  {
    path: '/sax',
    element: lazyPage(<Sax />),
    title: "Marc Plotkin | Sax Reel",
    description: "Saxophone performances and recordings by Marc Plotkin",
  },
  {
    path: '/saxophone',
    element: lazyPage(<Sax />),
    title: "Marc Plotkin | Sax Reel",
    description: "Saxophone performances and recordings by Marc Plotkin",
    canonicalPath: '/sax',
  },
  {
    path: '/hiring/video',
    element: lazyPage(<HiringVideo />),
    title: "Videographer / Editor Position | Marc Plotkin",
    description: "Join our team to create amazing music documentary content",
  },
  {
    path: '/marketing-intern',
    element: lazyPage(<MarketingIntern />),
    title: "Marketing Intern Position | Marc Plotkin",
    description: "Marketing internship opportunity in music and entertainment",
  },
  {
    path: '/interviewing-text',
    element: lazyPage(<InterviewingFlow />),
    title: "Interviewing Decision Flow | Marc Plotkin",
    description: "A framework for evaluating candidates in interviews",
  },
  {
    path: '/songlength',
    element: lazyPage(<SongLength />),
    title: "Song Length Plotter | Marc Plotkin",
    description: "How long are an artist's songs — and how has that changed over time? Search any artist and visualize their song durations across their entire career.",
    image: 'https://marcplotkin.com/images/songlength-og.png',
    imageType: 'image/png',
  }
];
